import * as React from 'react'
import './style.less'
import {Surface} from 'telstra-ui/components/surface/Surface'
import {SurfaceList} from 'telstra-ui/components/list/List'
import Skeleton from 'telstra-ui/components/skeleton/Skeleton'
import {getTileName} from '@telstra-connect/utils/helper/get-tile-name'

const mapOnDashboardSkeletonLoading = () => {
  return <Skeleton count={1} height="300px" />
}

export const InsightMetricSkeletonLoading = () => {
  return (
    <div className="tc-np-surface-metric-footer-skeleton">
      <Skeleton count={1} width="80%" height="24px" />
      <Skeleton count={1} width="8%" height="24px" />
    </div>
  )
}

const mapOnDashboardSkeletonFooter = () => {
  return (
    <div className="tc-np-surface-metric-footer">
      <InsightMetricSkeletonLoading />
    </div>
  )
}

const surfaceHeader = (
  <div className="tl-heading__container">
    <div className="__heading tl-loading" id="ui-np-card-heading-loading">
      {getTileName()}
    </div>
  </div>
)

export const CardSurfaceLoadingIndicator = () => {
  return (
    <div className="tc-np-surface-container" style={{height: '424px'}}>
      <Surface
        className="tl-custom-width tl-surface-dashboard tc-np-surface-loader ui-card-loading"
        name="surface-flat"
        id="ui-np-card"
      >
        <div className="tl-card-inner-content">
          <SurfaceList
            header={surfaceHeader}
            body={mapOnDashboardSkeletonLoading()}
            footer={mapOnDashboardSkeletonFooter()}
          />
        </div>
      </Surface>
    </div>
  )
}
